export default {
  'コースケ': {
    name: 'コースケ',
    icon: 'https://texture-asset.kirafan.cn/originalcharactericon/originalcharactericon_2.png',
    twitter: 'https://twitter.com/koucoc_kirafan',
  },
  '林檎アメ': {
    name: '林檎アメ',
    icon: 'https://card-asset.kirafan.cn/charaicon/charaicon_30041000.png',
    twitter: 'https://twitter.com/nilcric',
    gitlab: 'https://gitlab.com/circlelin',
  },
};
